import { render, staticRenderFns } from "./updateUserId.vue?vue&type=template&id=e1e8f0e2&"
import script from "./updateUserId.vue?vue&type=script&lang=js&"
export * from "./updateUserId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/system/updateUserId.vue"
export default component.exports